var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 12.1665H14.5M20.5 8.6665H8.5M20.5 15.8332H14.5M20.5 19.3332H8.5M9.35333 11.7065L11.9311 13.6398C12.1241 13.7846 12.2206 13.857 12.2551 13.9457C12.2853 14.0234 12.2853 14.1096 12.2551 14.1873C12.2206 14.2761 12.1241 14.3484 11.9311 14.4932L9.35333 16.4265C9.07868 16.6325 8.94135 16.7355 8.8264 16.7331C8.72637 16.731 8.63256 16.6841 8.57088 16.6053C8.5 16.5148 8.5 16.3432 8.5 15.9998V12.1332C8.5 11.7899 8.5 11.6182 8.57088 11.5277C8.63256 11.4489 8.72637 11.402 8.8264 11.3999C8.94135 11.3975 9.07868 11.5005 9.35333 11.7065Z",
    stroke: "#686E7A",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndent);
export default __webpack_public_path__ + "static/media/indent.db5f2a032893f2500d757fc400f057d4.svg";
export { ForwardRef as ReactComponent };